import { render, staticRenderFns } from "./DriverGroupForm.vue?vue&type=template&id=596273fe&scoped=true"
import script from "./DriverGroupForm.vue?vue&type=script&lang=js"
export * from "./DriverGroupForm.vue?vue&type=script&lang=js"
import style0 from "./DriverGroupForm.vue?vue&type=style&index=0&id=596273fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596273fe",
  null
  
)

export default component.exports